module.exports = __webpack_public_path__ + "static/chickenpenne-ce3bcd2b9a25e23a281d0393b43e9c13.jpg";